import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import { AppProvider } from "./context/AppContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Login from "./pages/Login";
import Register from "./pages/Register";
import TeacherDashboard from "./pages/TeacherDashboard";
import StudentDashboard from "./pages/StudentDashboard";
import RegistrationComplete from "./pages/RegistrationComplete";
import TeacherDetail from "./pages/TeacherDetail";
import SuperAdminDashboard from "./pages/SuperAdminDashboard";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const [user, setUser] = useState(null);
  const [approvedSchools, setApprovedSchools] = useState([]);
  const [isNavbarVisible, setNavbarVisibility] = useState(true);

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    setUser(storedUser);

    if (storedUser?.role === "teacher" && Array.isArray(storedUser.schools)) {
      const approved = storedUser.schools.filter((s) => s.isApproved);
      setApprovedSchools(approved);
    }
  }, []);

  const role = user?.role;
  const isSuperAdmin = !!user?.isSuperAdmin;

  const renderRoutes = () => {
    // 🔒 Belum login
    if (!user) {
      return (
        <>
          <Route path="/registration-complete" element={<RegistrationComplete />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </>
      );
    }

    // ✅ Route extra untuk super admin (selagi dah login)
    const superAdminRoute = isSuperAdmin ? (
      <Route path="/super-admin" element={<SuperAdminDashboard />} />
    ) : null;

    // 👨‍🏫 Guru + sekolah approved
    if (role === "teacher" && approvedSchools.length > 0) {
      return (
        <>
          {superAdminRoute}

          <Route
            path="/teacher/dashboard"
            element={<TeacherDashboard />}
          />
          <Route
            path="/teacher/detail"
            element={<TeacherDetail setNavbarVisibility={setNavbarVisibility} />}
          />
          {/* Default: guru pergi dashboard guru */}
          <Route
            path="*"
            element={<Navigate to="/teacher/dashboard" replace />}
          />
        </>
      );
    }

    // 👨‍🏫 Guru tapi belum ada sekolah lulus
    if (role === "teacher") {
      return (
        <>
          {superAdminRoute}

          <Route
            path="*"
            element={
              <h2 style={{ padding: "20px" }}>
                Akaun anda belum diluluskan oleh mana-mana sekolah.
              </h2>
            }
          />
        </>
      );
    }

    // 🧑‍🎓 Murid
    if (role === "student") {
      return (
        <>
          {superAdminRoute}

          <Route path="/student/dashboard" element={<StudentDashboard />} />
          <Route
            path="*"
            element={<Navigate to="/student/dashboard" replace />}
          />
        </>
      );
    }

    // fallback lain-lain role (kalau ada)
    return (
      <>
        {superAdminRoute}
        <Route path="*" element={<h2>404 Not Found</h2>} />
      </>
    );
  };

  const handleLogout = () => {
    const confirmLogout = window.confirm("Adakah anda pasti ingin log keluar?");
    if (!confirmLogout) return;

    localStorage.removeItem("user");
    setUser(null);
    setApprovedSchools([]);
    window.location.href = "/login";
  };

  return (
    <AppProvider>
      <Router>
        {user && isNavbarVisible && <Navbar onLogout={handleLogout} />}

        <Routes>{renderRoutes()}</Routes>

        {user && <Footer />}

        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
      </Router>
    </AppProvider>
  );
};

export default App;
